import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

const footerLinks = [
  { label: 'Home', href: '/' },
  { label: 'Operations', href: '/operations' },
  { label: 'Verify', href: '/verify' },
  { label: 'Registry', href: '/threat-registry' },
  { label: 'Fraud Awareness', href: '/fraud-awareness' },
  { label: 'Briefings', href: '/briefings' },
];

const socialLinks = [
  { label: 'Twitter', href: '#', icon: 'X' },
  { label: 'LinkedIn', href: '#', icon: 'in' },
];

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background" aria-label="Site footer">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        {/* Linear Single-Row Pattern */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo + Links */}
          <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-10">
            <Link href="/" className="flex items-center gap-2 group">
              <AppLogo size={24} />
              <span className="bracket-tag text-muted-foreground group-hover:text-foreground transition-colors">
                FORENSICDESK
              </span>
            </Link>
            <nav className="flex items-center gap-6 flex-wrap justify-center" aria-label="Footer navigation">
              {footerLinks?.map((link) => (
                <Link
                  key={link?.href}
                  href={link?.href}
                  className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-200 min-h-[44px] flex items-center"
                >
                  {link?.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Right: Social + Legal */}
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-3">
              {socialLinks?.map((s) => (
                <a
                  key={s?.label}
                  href={s?.href}
                  aria-label={s?.label}
                  className="w-8 h-8 border border-border flex items-center justify-center bracket-tag text-muted-foreground hover:text-foreground hover:border-primary transition-all duration-200"
                >
                  {s?.icon}
                </a>
              ))}
            </div>
            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <Link href="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
              <span className="text-border">·</span>
              <Link href="/terms" className="hover:text-foreground transition-colors">Terms</Link>
              <span className="text-border">·</span>
              <Link href="/logo-download" className="hover:text-foreground transition-colors">Brand Assets</Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="bracket-tag text-muted-foreground">
            © FORENSICDESK INTELLIGENCE OPERATIONS // EST. 2021. ALL RIGHTS RESERVED.
          </p>
          <p className="bracket-tag text-muted-foreground">
            [CLASSIFICATION: UNCLASSIFIED // OPERATIONAL USE ONLY]
          </p>
        </div>
      </div>
    </footer>
  );
}